export default class DtoCauseIntervention {
    constructor(obj) {
        this.interventionId = obj.interventionId // Int,
        this.interventionType = obj.interventionType // String,
        this.eventId = obj.eventId // Int,
        this.stationId = obj.stationId // Int
    }
}